import { useCallback, useState } from 'react';
import getCarcaseCar from '../../api/cars/getCarcaseCar';
import Select from '../Select/Select';

const SelectCarcase = ({ handleSetSelect, handleSetState, style, ...props }) => {
  const [data, setData] = useState([]);
  const onFocus = useCallback(() => {
    getCarcaseCar().then((res) => {
      const carcase = res.data.map((item) => {
        return { value: item.id, label: item.title };
      });

      setData(carcase);
    });
  }, []);

  return (
    <Select
      handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
      handleSetState={handleSetState}
      options={data}
      title={'ÐÑÐ·Ð¾Ð²'}
      placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'}
      onFocus={onFocus}
      style={style}
      {...props}
    />
  );
};

export default SelectCarcase;
